import React, { useState, useEffect } from 'react';
import { AuthProvider } from './firebase/AuthContext';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';
import NavbarComponent from './components/Navbar';
import AshwagandhaPage from './pages/AshwagandhaPage';
import CognitivePage from './pages/CognitivePage';
import VitaminPage from './pages/VitaminPage';
import WeightlossPage from './pages/WeightlossPage';
import MuscleStrenghtPage from './pages/Muscle&StrengthPage';
import ExerciseEquipmentPage from './pages/ExerciseEquipmentPage';
import HomeGymPage from './pages/HomeGymPage';
import HighProteinMeals from './pages/Blog/HighProteinMeals';
import VitaminDFoodsPage from './pages/Blog/VitaminDFoodsPage';
import CalmingMorningRoutinePage from './pages/Blog/CalmingMorningRoutinePage';
import BlogWeightlossPage from './pages/Blog/BlogWeightlossPage';
import BlogReduceStresAnxietyPage from './pages/Blog/BlogReduceStresAnxietyPage';
import BlogMuscleRecoveryPostWorkoutPage from './pages/Blog/BlogMuscleRecoveryPostWorkoutPage';
import HairSkinNailsSupplementsvsBalancedDietPage from './pages/Blog/HairSkinNailsSupplementsvsBalancedDietPage';
import BestHairRegrowthTreatmentsHowtoStopThinningPage from './pages/Blog/BestHairRegrowthTreatmentsHowtoStopThinningPage';
import HowToMakeRosemaryOilPage from './pages/Blog/HowToMakeRosemaryOilPage';
import DeepVeinThrombosisPreventionPage from './pages/Blog/DeepVeinThrombosisPreventionPage';
import WhatVitaminsShouldITakePage from './pages/Blog/WhatVitaminsShouldITakePage';
import BlogPage from './pages/Blog/MainBlogPage';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import LanguageSelector from './components/LanguageSelector';
import { getUserRegion } from './utils/helpers';
import './styles/components/footer.css';
import './styles/components/radiobutton.css';
import VitaminDCalculator from './pages/UserTools/VitaminDCalculator';
import VitaminB12Calculator from './pages/UserTools/VitaminB12Calculator';
import VitaminCCalculator from './pages/UserTools/VitaminCCalculator';
import VitaminIroncalculator from './pages/UserTools/VitaminIroncalculator';
import MagnesiumCalculator from './pages/UserTools/MagnesiumCalculator';
import MineralCalciumCalculator from './pages/UserTools/MineralCalciumCalculator';
import Omega3EssentialFattyAcidCalculator from './pages/UserTools/Omega3EssentialFattyAcid';
import VitaminFolateVitaminB9Calculator from './pages/UserTools/VitaminFolateVitaminB9Calculator';
import MineralZincCalculator from './pages/UserTools/MineralZincCalculator';
import VitaminKCalculator from './pages/UserTools/VitaminKCalculator';
import PotassiumSodiumCalculator from './pages/UserTools/PotassiumSodiumCalculator';
import VitaminACarotenoidCalculator from './pages/UserTools/VitaminACarotenoidCalculator';
import VitaminECalculator from './pages/UserTools/VitaminECalculator';
import BMIBodyfatCalculator from './pages/UserTools/BMIBodyfatCalculator';
import OneRepMaxCalculator from './pages/UserTools/OneRepMaxCalculator';
import VitaminBiotinCalculator from './pages/UserTools/VitaminBiotinCalculator';
import ToolsandApps from './pages/ToolsandApps';
import NotFoundPage from './pages/NotFoundPage';
import AiUserInput from './components/AiDashboard/AiMyNutritionStatus/AiUser/AiUserInput';
import MyNutritionStatus from './components/AiDashboard/MyNutritionStatus';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import ManageSubscriptionActions from './components/payments/ManageSubscriptionActions';
import RequireEntitlement from './components/payments/RequireEntitlement';
import CheckoutPage from './components/payments/CheckoutPage';
import CheckoutSuccess from './components/payments/CheckoutSuccess';
import CheckoutCancel from './components/payments/CheckoutCancel';
import AiNutritionLandingPage from './pages/AiNutritionLandingPage';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import DeleteAccount from './components/AiDashboard/AiMyNutritionStatus/AiUser/AiUserSettings/DeleteAccount';
import SignInPage from './pages/SignInPage';

const primaryLandingPath = '/ai-nutrition-vitamins-minerals';
const signInPath = '/sign-in';
const legacySignInPath = '/signin';

function App() {
  const [region, setRegion] = useState(
    process.env.NODE_ENV === 'development' ? 'US' : null
  );

  useEffect(() => {
    async function fetchRegion() {
      const userRegion = await getUserRegion();
      setRegion(userRegion === 'US' ? 'US' : 'EU');
    }

    if (process.env.NODE_ENV !== 'development') {
      fetchRegion();
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <NavbarComponent />
        <LanguageSelector />

        {region && <PageTracker region={region} />}

        <div className="content">
          <Routes>
            <Route
              path={primaryLandingPath}
              element={<AiNutritionLandingPage region={region} />}
            />

            <Route
              path={signInPath}
              element={<SignInPage />}
            />
            <Route
              path={legacySignInPath}
              element={<LegacySignInRedirect />}
            />

            <Route
              path="/"
              element={<AiNutritionLandingPage region={region} />}
            />

            <Route
              path="/top-rated-vitamins"
              element={<VitaminPage region={region} />}
            />
            <Route
              path="/ashwagandha"
              element={<AshwagandhaPage region={region} />}
            />
            <Route
              path="/lionsmane"
              element={<CognitivePage region={region} />}
            />
            <Route
              path="/weightloss"
              element={<WeightlossPage region={region} />}
            />
            <Route
              path="/best-whey-protein"
              element={<MuscleStrenghtPage region={region} />}
            />
            <Route
              path="/workout-gear"
              element={<ExerciseEquipmentPage region={region} />}
            />
            <Route
              path="/best-home-gym"
              element={<HomeGymPage region={region} />}
            />

            <Route path="/privacy" element={<Privacy region={region} />} />
            <Route path="/cookies" element={<Cookies region={region} />} />

            <Route
              path="/qualityvitamins"
              element={
                <ExternalRedirect url="https://purehealthnexus.com/top-rated-vitamins" />
              }
            />
            <Route
              path="/home-gym"
              element={
                <ExternalRedirect url="https://purehealthnexus.com/best-home-gym" />
              }
            />
            <Route
              path="/muscle-strength"
              element={
                <ExternalRedirect url="https://purehealthnexus.com/best-whey-protein" />
              }
            />

            <Route path="/blog" element={<BlogPage region={region} />} />
            <Route
              path="/high-protein-meals"
              element={<HighProteinMeals region={region} />}
            />
            <Route
              path="/top-vitamin-d-foods"
              element={<VitaminDFoodsPage region={region} />}
            />
            <Route
              path="/calming-morning-routines"
              element={<CalmingMorningRoutinePage region={region} />}
            />
            <Route
              path="/weight-loss-tips"
              element={<BlogWeightlossPage region={region} />}
            />
            <Route
              path="/how-to-reduce-stress-and-anxiety"
              element={<BlogReduceStresAnxietyPage region={region} />}
            />
            <Route
              path="/muscle-recovery-&-post-workout-care"
              element={
                <BlogMuscleRecoveryPostWorkoutPage region={region} />
              }
            />
            <Route
              path="/best-hair-skin-nails-vitamins-vs-balanced-diet"
              element={
                <HairSkinNailsSupplementsvsBalancedDietPage region={region} />
              }
            />
            <Route
              path="/best-hair-regrowth-treatments-stop-thinning-restore-hair-naturally"
              element={
                <BestHairRegrowthTreatmentsHowtoStopThinningPage region={region} />
              }
            />
            <Route
              path="/how-to-make-rosemary-oil-at-home-for-stronger-healthier-hair-plus-the-science-behind-how-they-work"
              element={<HowToMakeRosemaryOilPage region={region} />}
            />
            <Route
              path="/deep-vein-thrombosis-how-to-prevent-it-naturally-with-supplements-&-lifestyle-tips"
              element={<DeepVeinThrombosisPreventionPage region={region} />}
            />
            <Route
              path="/what-vitamins-should-i-take"
              element={<WhatVitaminsShouldITakePage region={region} />}
            />

            <Route path="/apps" element={<ToolsandApps region={region} />} />

            <Route
              path="/vitamin-d-calculator"
              element={<VitaminDCalculator region={region} />}
            />
            <Route
              path="/vitamin-b12-calculator"
              element={<VitaminB12Calculator region={region} />}
            />
            <Route
              path="/vitamin-c-calculator"
              element={<VitaminCCalculator region={region} />}
            />
            <Route
              path="/mineral-iron-calculator"
              element={<VitaminIroncalculator region={region} />}
            />
            <Route
              path="/mineral-magnesium-calculator"
              element={<MagnesiumCalculator region={region} />}
            />
            <Route
              path="/mineral-calcium-calculator"
              element={<MineralCalciumCalculator region={region} />}
            />
            <Route
              path="/omega-3-fatty-acid-calculator"
              element={<Omega3EssentialFattyAcidCalculator region={region} />}
            />
            <Route
              path="/vitamin-folate-calculator"
              element={
                <VitaminFolateVitaminB9Calculator region={region} />
              }
            />
            <Route
              path="/mineral-zinc-calculator"
              element={<MineralZincCalculator region={region} />}
            />
            <Route
              path="/vitamin-k-calculator"
              element={<VitaminKCalculator region={region} />}
            />
            <Route
              path="/potassium-sodium-calculator"
              element={<PotassiumSodiumCalculator region={region} />}
            />
            <Route
              path="/vitamin-a-carotenoid-calculator"
              element={<VitaminACarotenoidCalculator region={region} />}
            />
            <Route
              path="/vitamin-e-calculator"
              element={<VitaminECalculator region={region} />}
            />
            <Route
              path="/bmi-bodyfat-calculator"
              element={<BMIBodyfatCalculator region={region} />}
            />
            <Route
              path="/one-rep-max-calculator"
              element={<OneRepMaxCalculator region={region} />}
            />
            <Route
              path="/vitamin-biotin-calculator"
              element={<VitaminBiotinCalculator region={region} />}
            />

            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />

            <Route
              path="/ai-assistant"
              element={
                <ProtectedRoute>
                  <RequireEntitlement>
                    <AiUserInput />
                  </RequireEntitlement>
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-nutrition-status"
              element={
                <ProtectedRoute>
                  <RequireEntitlement>
                    <MyNutritionStatus />
                  </RequireEntitlement>
                </ProtectedRoute>
              }
            />
            <Route
              path="/account/billing"
              element={
                <ProtectedRoute>
                  <ManageSubscriptionActions />
                </ProtectedRoute>
              }
            />

            <Route
              path="/delete-account"
              element={
                <ProtectedRoute>
                  <DeleteAccount />
                </ProtectedRoute>
              }
            />

            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/success"
              element={
                <ProtectedRoute>
                  <CheckoutSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout/cancel"
              element={
                <ProtectedRoute>
                  <CheckoutCancel />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </AuthProvider>
  );
}

function LegacySignInRedirect() {
  const location = useLocation();
  return (
    <Navigate
      to={`${signInPath}${location.search}${location.hash}`}
      state={location.state}
      replace
    />
  );
}

function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
}

function PageTracker({ region }) {
  const location = useLocation();

  useEffect(() => {
    if (window.ppms && window.ppms.tm) {
      window.ppms.tm.api('trackPageView', location.pathname, { region });
    }
  }, [location, region]);

  return null;
}

export default App;
